<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Demande de contrat</span>
        <h3 class="page-title">Gestion des demandes de contrat</h3>
      </div>
    </div>
    <!-- Table -->
    <div class="row">
      <div class="col">
        <div
          class="card card-small mb-4 mt-3"
          v-if="loading || !user.connected"
        >
          <div class="card-body">
            <spinner-dot />
          </div>
        </div>
        <div v-else>
          <div class="card card-small mb-4 mt-3">
            <div class="header-data-table">
              <h5 class="header-data-table__heading">Liste des demandes</h5>
            </div>
            <ContractRequestFilter :statusList="statusList" />
            <change-date-dialog
              :dialog="dialog"
              :toggleDialog="toggleDialog"
              :request="requestToEdit"
            />
            <div class="card-body">
              <data-table
                :data="dayOffGridData"
                :fields="gridColumnsTitle"
                :selectedFields="daysOffFields"
                :fieldsGrid="gridColumnsFields"
                :tableState="state"
                :count="count"
              ></data-table>
            </div>
          </div>
        </div>
        <simple-modal ref="reasonModal" :motif="selectedMotif" />
      </div>
    </div>
  </div>
</template>

<script>
import daysOffType from "../../data/daysOff/daysOffType";
import TimeUtils from "../../utils/TimeUtils";
import moment from "moment-timezone";
import SpinnerDot from "../../components/layout/Loading/spinner-dot";
import DataTable from "../../components/contract/dataTable";
import SimpleModal from "../../components/abscenceRequest/SimpleModal";
import absceneRequestGrid from "../../data/dataTable/absceneRequestGrid.json";
import ContractRequestFilter from "./ContractRequestFilter.vue";
import ChangeDateDialog from "../absenceRequest/ChangeDateDialog";
export default {
  name: "contract-request-management",
  components: {
    SimpleModal,
    DataTable,
    SpinnerDot,
    ContractRequestFilter,
    ChangeDateDialog,
  },
  props: ["reference"],
  data() {
    return {
      dialog: false,
      daysOffHistory: [],
      requestToEdit: {},
      count: 0,
      model: {},
      contractType: {
        CEE: "CEE",
        LEARN: "Apprentissage",
        UNPAID: "Bénévole",
        CDD: "CDD PEC",
        CDI: "CDI",
        OTHER: "Autre",
      },
      selectedMotif: "",
      // all values available for the table
      gridColumnsFields: absceneRequestGrid.grid,
      gridColumnsTitle: absceneRequestGrid.grid.map((grid) => grid.title),
      loading: true,
      daysOffFields: [
        "Demandeur",
        "Vacataire",
        "Structure",
        "Type de contrat",
        "Date de création",
        "Statut",
        "Action",
      ],

      daysOffFieldsGridFill: {
        // "Action nécéssaire": request => {

        //   //Prendre tous les answers de cette demande
        //   let answers = request.answers;
        //   //Variable du status
        //   let status;
        //   //Variable true si l'action est nécéssaire et false sinon
        //   let action;
        //   //La reference du user courant
        //   let userReference = this.$store.state.user.informations.reference;
        //   //Parcourir les answers
        //   for (let i in answers) {
        //     //Instancier chaque answer
        //     let answer = answers[i];
        //     //Chercher la answer correspondante à notre user
        //     if (answer.userReference == userReference) {

        //       //Prendre e status
        //       status = answer.status;

        //     }
        //   }
        //   if (status===undefined){
        //     return true
        //   }
        //   //Si le status du user est pending et le status de la demande est null (il est ni ACCEPTED ni REJECTED)
        //   if (status.toLowerCase() == "pending" && request.status == null) {
        //     action = true;
        //   } else {
        //     action = false;
        //   }
        //   return action;
        // },
        Demandeur: (request) =>
          request.applicantFirstName + " " + request.applicantLastName,
        Vacataire: (request) => request.firstName + " " + request.lastName,
        Structure: (request) => request.structureName,
        "Type de contrat": (request) =>
          this.contractType[request.typeOfContract],
        "Date de création": (request) =>
          new Date(request.creationDate).toLocaleDateString("fr-FR"),
        Statut: (request) => request.answers[0].status || "En attente...",
        Action: (request) => {
          return [
            {
              component: "button-td",
              class: "btn-accent",
              content: "Voir la demande",
              action: () => this.goToRequest(request),
              id: request.declineReason,
            },
          ];
        },
      },
      state: {
        page: 1,
        perPage: 10,
        field: "Date de cr�ation",
        ascending: false,
      },
      statusList: ["PENDING", "ACCEPTED", "REFUSED", "TREATED"],
      filterQuery: {},
      filteredDaysOff: [],
      dayOffGridData: [],
    };
  },

  watch: {
    state: {
      handler() {
        this.daysOffFetch();
      },
      deep: true,
    },
    filterQuery() {
      // searchDaysOffFetch
      if (Object.keys(this.filterQuery).length === 0) {
        this.daysOffFetch();
      } else {
        this.searchDaysOffFetch();
      }
    },
    daysOffHistory() {
      if (this.filterQuery.dates) {
        const { from, to } = this.filterQuery.dates;
        const filtered = this.daysOffHistory.filter((item) => {
          const { dates } = item;
          if (from && to) {
            return dates[0].from >= from && dates[0].to <= to;
          } else if (!from) {
            return dates[0].to <= to;
          } else if (!to) {
            return dates[0].from >= from;
          }
          return true;
        });
        this.filteredDaysOff = this.filterQuery.status
          ? this.filterQuery.status === "PENDING"
            ? filtered.filter((item) => item.status === undefined)
            : filtered.filter((item) => item.status === this.filterQuery.status)
          : filtered;
      } else {
        this.filteredDaysOff = this.filterQuery.status
          ? this.filterQuery.status === "PENDING"
            ? this.daysOffHistory.filter((item) => item.status === undefined)
            : this.daysOffHistory.filter(
                (item) => item.status === this.filterQuery.status
              )
          : this.daysOffHistory;
      }
    },
    filteredDaysOff() {
      this.dayOffGridData = this.filteredDaysOff.map((user) => {
        const res = {};
        this.daysOffFields.forEach((field) => {
          if (this.daysOffFieldsGridFill[field]) {
            res[field] = this.daysOffFieldsGridFill[field](user);
          }
          // res["Action nécéssaire"] = this.daysOffFieldsGridFill[
          //   "Action nécéssaire"
          // ](user);
        });
        return res;
      });
    },
  },

  computed: {
    user() {
      return this.$store.state.user.informations;
    },
  },

  methods: {
    toggleDialog() {
      this.dialog = !this.dialog;
    },
    cancel_demand_with_restaure(request, numberOfDays) {
      const model = {
        status: "CANCELED",
        userReference: this.user.reference,
        motif: "Annulée par le comptable",
      };
      this.$services.absenceRequest
        .confirmRequest(request.reference, model)
        .then(({ data }) => {
          this.request = data;
          this.alreadyAnswered(request);
          this.$miniToastr.success("Cette demande a été annulée");
          this.daysOffFetch();
        })
        .catch(() => (this.loading = false));
      this.$services.user
        .updateLeftVacations({
          selectedUsers: [request.userReference],
          days: Number(numberOfDays),
          mode: "INCREMENT",
        })
        .then(() => {
          this.$miniToastr.success(this.$t("user.edit.success"));
          this.selectedUsers = [];
          this.appliedToAll = false;
          this.fetchUsers();
        })
        .catch(() => (this.loading = false));
    },
    edit_demand(request) {
      this.requestToEdit = request;
      this.dialog = true;
    },
    alreadyAnswered(request) {
      const a = request.answers.find(
        (answer) => answer.userReference === this.user.reference
      );
      if (a.status !== "PENDING") {
        this.answered = true;
      }
    },

    cancel_demand(request) {
      const model = {
        status: "CANCELED",
        userReference: this.user.reference,
        motif: "Annulée par le comptable",
      };

      this.$services.absenceRequest
        .confirmRequest(request.reference, model)
        .then(({ data }) => {
          this.request = data;
          this.alreadyAnswered(request);
          this.$miniToastr.success("Cette demande a été annulée");
          this.daysOffFetch();
        })
        .catch(() => (this.loading = false));
    },
    check_compta() {
      const { permissions } = this.$store.state.user.informations;
      const permission = permissions.find(
        (item) => item.groupReference === "_compta"
      );

      return permission != undefined;
    },
    showReason(reason) {
      this.selectedMotif = reason;
      this.$refs.reasonModal.openModal();
    },
    goToLeaveRequest(request) {
      this.$router.push(`/demandes/repondre/${request.reference}`);
    },
    goToRequest(request) {
      this.$router.push(`/contracts/${request.reference}`);
    },
    async daysOffFetch() {
      console.warn("daysOffFetch trigged");
      this.loading = true;
      const types = ["CP", "CS", "OTHER"];
      await this.$services.contractRequestService
        .findAllUnderCharge(
          this.user.reference,
          null,
          null,
          null,
          this.state.page,
          this.state.perPage,
          this.state.field,
          this.state.ascending,
          this.gridColumnsFields
        )
        .then((res) => {
          this.loading = false;
          this.count = res.data.count;
          this.daysOffHistory = res.data.data;
          console.warn(this.daysOffHistory);
        });
    },
    async searchDaysOffFetch() {
      console.log(
        "%c filterQuery : ",
        "color: red; font-size: 25px;",
        this.filterQuery
      );
      console.warn("searchDaysOffFetch trigged");
      this.loading = true;
      const types = ["CP", "CS", "OTHER"];
      await this.$services.contractRequestService
        .findAllUnderCharge(this.user.reference, {
          status:
            this.filterQuery.status === "PENDING"
              ? undefined
              : this.filterQuery.status,
          firstName: this.filterQuery.firstName
            ? this.filterQuery.firstName
            : undefined,
          lastName: this.filterQuery.lastName
            ? this.filterQuery.lastName
            : undefined,
          applicantFirstName: this.filterQuery.applicantFirstName
            ? this.filterQuery.applicantFirstName
            : undefined,
          applicantLastName: this.filterQuery.applicantLastName
            ? this.filterQuery.applicantLastName
            : undefined,
          structureID: this.filterQuery.structureID
            ? this.filterQuery.structureID
            : undefined,
          dateFrom: this.filterQuery.startDate
            ? Date.parse(this.filterQuery.startDate)
            : undefined,
          dateTo: this.filterQuery.endDate
            ? Date.parse(this.filterQuery.endDate)
            : undefined,
        })
        .then((res) => {
          console.log(
            "%cData from search : ",
            "color: red; font-size: 20px;",
            res
          );
          this.loading = false;
          this.count = res.data.count;
          this.daysOffHistory = res.data;
        });
    },
  },

  mounted() {
    if (!this.reference) {
      this.model = { userReference: this.user.reference };
    } else {
      this.model = { userReference: this.reference };
    }
    this.filterQuery = this.$store.state.absenceRequest.filter;
    this.daysOffFetch();
    this.$root.$on("refresh", () => {
      this.daysOffFetch();
    });
    this.$root.$on("searchRequests", (query) => {
      console.log(
        "%c from mounted filter Query",
        "color: green; font-size: 30px;",
        query
      );
      this.filterQuery = query;
    });
  },
};
</script>

<style></style>
